module.exports = __webpack_public_path__ + "static/img/freezer_trailer.9ccf94e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/freezer_trailer.jpg
// module id = fyro
// module chunks = 1